import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Header from "./Header"; // Our new header component
import PublicProfilePublicPage from "./PublicProfilePublicPage";

function App() {
    return (
        <BrowserRouter>
            {/* 1) The Header is outside <Routes> so it appears on every page */}
            <Header />
            {/* 2) Use <Routes> to define your different pages */}
            <Routes>
                <Route
                    path="/public-profile/:targetUserId"
                    element={<PublicProfilePublicPage />}
                />
                {/* Fallback for unknown routes, optional */}
                <Route
                    path="*"
                    element={<div>404: Page Not Found</div>}
                />
            </Routes>
        </BrowserRouter>
    );
}

export default App;